<template>
  <div id="app">
    <header-bar v-if="!isHeadShow"></header-bar>
    <div v-if="!isHeadShow" class="head-slot"></div>
    <router-view></router-view>
  </div>
</template>

<script>
  import HeaderBar from './components/header/Index'

  export default {
    name: 'App',
    data () {
      return {
        isHeadShow: false
      }
    },
    components:{
      HeaderBar
    },
    watch:{
      $route:function(to,from){
        let self = this;
        this.$nextTick(function(){
          self.isHeadShow = false
          let meta = self.$route.meta
          if(!meta.isnavbar){
            self.isHeadShow = true
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .head-slot{
    width: 100%;
    height: 190px;
  }
</style>





// WEBPACK FOOTER //
// src/App.vue